module.exports = __webpack_public_path__ + "static/media/pdf-logo.de52c718.jpg";